<template>
    <client-page>
        <div class="client-content-wrap">
            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap">
                        <h2 class="client-title--xxxl">인사말</h2>
                    </div>

                    <v-row class="row--xl">
                        <v-col cols="12" lg="4">
                            <v-img max-width="724" src="/images/about/greeting/ceo.jpg" alt="" class="mx-auto"></v-img>
                        </v-col>
                        <v-col cols="12" lg="8">
                            <v-card tile flat min-height="430" img="/images/about/greeting/bg-logo.png" class="text-content">
                                <v-responsive :aspect-ratio="778 / 519">
                                    <div class="page-text page-text--lg">
                                        <p>
                                            위드캔복지재단은 <strong class="primary--text">“사람 중심의 복지, 더 나은 세상을 향해”</strong>라는 미션 아래, <br class="d-none d-xl-block" />
                                            모든 이웃이 차별 없이 존엄한 삶을 누릴 수 있도록 노력하고 있습니다.
                                        </p>
                                        <br />
                                        <p>
                                            1989년 설립 이후, 국내외 취약계층을 위한 생애주기별 맞춤형 복지사업과 국제협력 프로그램을 통해 <br class="d-none d-xl-block" />
                                            지속 가능한 변화를 추구해 왔습니다. 이러한 노력은 여러분의 지속적인 관심과 참여 덕분에 가능했습니다.
                                        </p>
                                        <br />
                                        <p>
                                            앞으로도 저희 위드캔복지재단은 전문성과 혁신을 바탕으로 포용적이고 지속 가능한 복지 서비스를 제공하며, <br class="d-none d-xl-block" />
                                            나눔과 협력의 가치를 실천하겠습니다. 함께 성장하는 더 나은 미래를 만들어가기 위해 여러분의 따뜻한 관심과 <br class="d-none d-xl-block" />
                                            참여를 부탁드립니다.
                                        </p>
                                        <br />
                                        <p>감사합니다</p>
                                    </div>
                                </v-responsive>
                                <div class="from page-text page-text--lg line-height-1 grey-1--text font-weight-bold">위드캔복지재단 이사장 전선영</div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </section>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";

export default {
    components: {
        ClientPage,
    },
};
</script>

<style lang="scss" scoped>
.text-content {
    position: relative;
    background-size: 100% !important;
    .from {
        position: absolute;
        bottom: 0;
        right: 0;
    }
}
@media (min-width: 768px) {
}
</style>